import {createBrowserRouter} from "react-router";
// Public
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import {Register} from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

// Layout
import {RootLayout} from "@/layouts/RootLayout";
import Logout from "@/pages/auth/Logout";
import AppLayout from "@/layouts/AppLayout";
import NotFound from "@/pages/NotFound";
import {UserLayout} from "@/layouts/UserLayout";
import {EmailLayout} from "@/layouts/EmailLayout";

// User
import {OrgInviteUser} from "@/pages/org/admin/OrgInviteUser";
import AddOrgSpecies from "@/pages/org/admin/OrgAddSpecies";
import {PublicOrgList} from "@/pages/platform/PublicOrgList";
import {AdminEditOrg} from "@/pages/admin/AdminEditOrg";
import {UserHome} from "@/pages/user/UserHome";
import {UserRecords} from "@/pages/user/UserRecords";
import {UserEvents} from "@/pages/user/UserEvents";
import {UserOrgs} from "@/pages/user/UserOrgs";
// Org
import OrgHomePage from "@/pages/org/OrgHomePage";
import {OrgUserLayout} from "@/layouts/OrgUserLayout";
import {OrgAdminLayout} from "@/layouts/OrgAdminLayout";
import {SystemAdminLayout} from "@/layouts/SystemAdminLayout";
import OrgAddRecord from "@/pages/org/admin/OrgAddRecord";
import RecordDetail from "@/pages/org/OrgRecordDetail";
import OrgRecords from "@/pages/org/OrgRecords";
import OrgSpecies from "@/pages/org/OrgSpecies";
import {OrgSpeciesDetails} from "@/pages/org/OrgSpeciesDetails";
import OrgEvents from "@/pages/org/OrgEvents";
import {OrgMessages} from "@/pages/org/admin/OrgMessages";
import {OrgMessageDetail} from "@/pages/org/admin/OrgMessageDetail";
import {OrgLayout} from "@/layouts/OrgLayout";
import OrgUsers from "@/pages/org/admin/OrgUsers";
import OrgEventDetail from "@/pages/org/OrgEventDetail";
import OrgAddEvent from "@/pages/org/admin/OrgAddEvent";
import OrgEventEdit from "@/pages/org/admin/OrgEventEdit";
import OrgRecordDetail from "@/pages/org/OrgRecordDetail";
import OrgEditRecord from "@/pages/org/admin/OrgEditRecord";
// Admin
import {AdminUserCreate} from "@/pages/admin/AdminUserCreate";
import {AdminEditUser} from "@/pages/admin/AdminEditUser";
import {AdminUserDetail} from "@/pages/admin/AdminUserDetail";
import {AdminSpecies} from "@/pages/admin/AdminSpecies";
import {AdminSpeciesDetail} from "@/pages/admin/AdminSpeciesDetail";
import {AdminOrgs} from "@/pages/admin/AdminOrgs";
import {AdminUsers} from "@/pages/admin/AdminUsers";
import {AdminOrgCreate} from "@/pages/admin/AdminOrgCreate";
import {AdminRecords} from "@/pages/admin/AdminRecords";
import {AdminRecordDetail} from "@/pages/admin/AdminRecordDetail";
import {AdminOrgDetail} from "@/pages/admin/AdminOrgDetail";

// Admin Email
import {EmailHome} from "@/pages/EmailHome";
import {Privacy} from "@/pages/Privacy";
import {Terms} from "@/pages/Terms";
import {Cookies} from "@/pages/Cookies";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: RootLayout,
    children: [
      {index: true, Component: Home},
      {path: "login", Component: Login},
      {path: "logout", Component: Logout},
      {path: "register", Component: Register},
      {path: "forgot-password", Component: ForgotPassword},
      {path: "reset-password", Component: ResetPassword},
      {path: "privacy-policy", Component: Privacy},
      {path: "terms-of-service", Component: Terms},
      {path: "cookies-policy", Component: Cookies},
      {path: "users/invite", Component: OrgInviteUser},
    ],
  },
  {
    path: "app",
    Component: AppLayout,
    children: [
      {
        path: "",
        Component: UserLayout,
        children: [
          {index: true, Component: UserHome},
          {
            path: "records",
            Component: UserRecords,
          },
          {
            path: "record/:recordId",
            Component: RecordDetail,
          },
          {
            path: "events",
            Component: UserEvents,
          },
          {path: "organisations", Component: UserOrgs},
          {path: "explore", Component: PublicOrgList},
        ],
      },
      {
        path: "org/:orgId",
        Component: OrgLayout,
        children: [
          // All Org Users (any role)
          {
            Component: OrgUserLayout,
            children: [
              {index: true, Component: OrgHomePage},
              {path: "records", Component: OrgRecords},
              {path: "record/:recordId", Component: OrgRecordDetail},
              {path: "species", Component: OrgSpecies},
              {path: "species/:speciesId", Component: OrgSpeciesDetails},
              {path: "events", Component: OrgEvents},
              {path: "event/:eventId", Component: OrgEventDetail},
            ],
          },
          // Org Admins only
          {
            Component: OrgAdminLayout,
            children: [
              {path: "records/add", Component: OrgAddRecord},
              {path: "record/:recordId/edit", Component: OrgEditRecord},
              {path: "addSpecies", Component: AddOrgSpecies},
              {path: "users", Component: OrgUsers},
              {path: "users/invite", Component: OrgInviteUser},
              {path: "events/add", Component: OrgAddEvent},
              {path: "events/:eventId/edit", Component: OrgEventEdit},
              {path: "messages", Component: OrgMessages},
              {path: "messages/:messageId", Component: OrgMessageDetail},
            ],
          },
        ],
      },
      {
        path: "admin", // app/admin
        Component: SystemAdminLayout,
        children: [
          // orgs
          {path: "orgs/manage", Component: AdminOrgs},
          {path: "orgs/create", Component: AdminOrgCreate},
          {path: "orgs/:orgId", Component: AdminOrgDetail},
          {path: "org/:orgId/edit", Component: AdminEditOrg},
          {path: "speciesDetail/:speciesId", Component: AdminSpeciesDetail},
          {path: "species", Component: AdminSpecies},
          {path: "records", Component: AdminRecords},
          {path: "record/:recordId", Component: AdminRecordDetail},
          {path: "users", Component: AdminUsers},
          {path: "users/create", Component: AdminUserCreate},
          {path: "user/:userId/edit", Component: AdminEditUser},
          {path: "user/:userId", Component: AdminUserDetail},
        ],
      },
    ],
  },
  {
    path: "email",
    Component: EmailLayout,
    children: [{index: true, Component: EmailHome}],
  },
  // Catch-all route for 404 errors
  {
    path: "*",
    Component: NotFound,
  },
]);
